// extracted by mini-css-extract-plugin
export default {"youTube":"OurYouTubeChannel_youTube__wwXLc","youTubeContent":"OurYouTubeChannel_youTubeContent__l7U3B","youTubeLink":"OurYouTubeChannel_youTubeLink__zFMzE"};